<p class="text-title-lgx-bold">Hábitos</p>
<p class="text-info-bold-xs mt-xxs mb-xlg">CUÉNTANOS SOBRE TUS HÁBITOS</p>

<form novalidate [formGroup]="form" class="tw-w-full">
  <div class="tw-p-5 tw-rounded-md tw-border tw-border-solid tw-border-gray-100">
    <div nz-row [nzGutter]="[30, 30]">
      <div nz-col nzXs="24" nzMd="8">
        <label nz-checkbox formControlName="drinkAlcohol" class="tw-flex tw-items-center" (ngModelChange)="onChangeDrinkAlcohol($event)">
          <div class="tw-flex tw-items-center">
            <img src="./../../../assets/images/icons/icons8-cerveza-100.png" class="tw-w-8 tw-mr-2" alt="">
            <p class="text-info">¿Bebe alcohol?</p>
          </div>
        </label>
      </div>
      <div nz-col nzXs="24" nzMd="8">
        <nz-select [nzDisabled]="!form.get('drinkAlcohol').value" formControlName="drinkAlcoholFrequency" nzBorderless class="tw-w-full">
          <nz-option *ngFor="let frequency of frequencies" [nzValue]="frequency.value" [nzLabel]="frequency.label"></nz-option>
        </nz-select>
      </div>
      <div nz-col nzXs="24" nzMd="8">
        <div class="tw-flex tw-items-center tw-justify-between">
          <p class="text-info tw-mr-2">¿Cuántas copas bebe al día?</p>
          <nz-input-number [nzDisabled]="!form.get('drinkAlcohol').value" [nzMin]="0" formControlName="cupAlcoholPerDay" style="max-width: 60px;"></nz-input-number>
        </div>
      </div>
    </div>
  </div>

  <div class="tw-mt-5 tw-p-5 tw-rounded-md tw-border tw-border-solid tw-border-gray-100">
    <div nz-row [nzGutter]="[30, 30]">
      <div nz-col nzXs="24" nzMd="8">
        <label nz-checkbox formControlName="smoke" class="tw-flex tw-items-center" (ngModelChange)="onChangeSmoke($event)">
          <div class="tw-flex tw-items-center">
            <img src="./../../../assets/images/icons/icons8-cigar-100.png" class="tw-w-8 tw-mr-2" alt="">
            <p class="text-info">¿Fuma?</p>
          </div>
        </label>
      </div>
      <div nz-col nzXs="24" nzMd="8">
        <nz-select [nzDisabled]="!form.get('smoke').value" formControlName="smokeFrequency" nzBorderless class="tw-w-full">
          <nz-option *ngFor="let frequency of frequencies" [nzValue]="frequency.value" [nzLabel]="frequency.label"></nz-option>
        </nz-select>
      </div>
      <div nz-col nzXs="24" nzMd="8">
        <div class="tw-flex tw-items-center tw-justify-between">
          <p class="text-info tw-mr-2">¿Cuántos cigarros fuma al día?</p>
          <nz-input-number [nzDisabled]="!form.get('smoke').value" [nzMin]="0" formControlName="cigarettesPerDay" style="max-width: 60px;"></nz-input-number>
        </div>
      </div>
    </div>
  </div>

  <div class="tw-mt-5 tw-p-5 tw-rounded-md tw-border tw-border-solid tw-border-gray-100">
    <div nz-row [nzGutter]="[30, 30]">
      <div nz-col nzXs="24" nzMd="8">
        <label nz-checkbox formControlName="drinkCoffee" class="tw-flex tw-items-center" (ngModelChange)="onChangeDrinkCoffee($event)">
          <div class="tw-flex tw-items-center">
            <img src="./../../../assets/images/icons/icons8-coffee-pot-100.png" class="tw-w-8 tw-mr-2" alt="">
            <p class="text-info">¿Toma café?</p>
          </div>
        </label>
      </div>
      <div nz-col nzXs="24" nzMd="8">
        <nz-select [nzDisabled]="!form.get('drinkCoffee').value" formControlName="drinkCoffeeFrequency" nzBorderless class="tw-w-full">
          <nz-option *ngFor="let frequency of frequencies" [nzValue]="frequency.value" [nzLabel]="frequency.label"></nz-option>
        </nz-select>
      </div>
      <div nz-col nzXs="24" nzMd="8">
        <div class="tw-flex tw-items-center tw-justify-between">
          <p class="text-info tw-mr-2">¿Cuántas tazas toma al día?</p>
          <nz-input-number [nzDisabled]="!form.get('drinkCoffee').value" [nzMin]="0" formControlName="cupCoffeePerDay" style="max-width: 60px;"></nz-input-number>
        </div>
      </div>
    </div>
  </div>
</form>

<!-- <form novalidate [formGroup]="form" class="tw-w-full">
  <div class="tw-p-5 tw-rounded-md tw-border tw-border-solid tw-border-gray-100">
    <div nz-row [nzGutter]="[30, 30]">
      <div nz-col nzXs="24" nzMd="8">
        <label nz-checkbox formControlName="drinkAlcohol" class="tw-flex tw-items-center tw-h-full">
          <div class="tw-flex tw-items-center">
            <img src="./../../../assets/images/icons/icons8-cerveza-100.png" class="tw-w-8 tw-mr-2" alt="">
            <p class="text-info">¿Bebe alcohol?</p>
          </div>
        </label>
      </div>
      <div nz-col nzXs="24" nzMd="8" class="tw-flex tw-items-center">
        <nz-select formControlName="drinkAlcoholFrequency" nzBorderless class="tw-w-full">
          <nz-option *ngFor="let frequency of frequencies" [nzValue]="frequency.value" [nzLabel]="frequency.label"></nz-option>
        </nz-select>
      </div>
      <div nz-col nzXs="24" nzMd="8">
        <div class="tw-flex tw-flex-col tw-items-start">
          <p class="text-info tw-mr-2 tw-mb-1">¿Cuántas copas bebe al día?</p>
          <app-input-number [min]="0" [formControl]="form.controls['cupAlcoholPerDay']"></app-input-number>
        </div>
      </div>
    </div>
  </div>

  <div class="tw-mt-5 tw-p-5 tw-rounded-md tw-border tw-border-solid tw-w- tw-border-gray-100">
    <div nz-row [nzGutter]="[30, 30]">
      <div nz-col nzXs="24" nzMd="8">
        <label nz-checkbox formControlName="smoke" class="tw-flex tw-items-center tw-h-full">
          <div class="tw-flex tw-items-center">
            <img src="./../../../assets/images/icons/icons8-cigar-100.png" class="tw-w-8 tw-mr-2" alt="">
            <p class="text-info">¿Fuma?</p>
          </div>
        </label>
      </div>
      <div nz-col nzXs="24" nzMd="8" class="tw-flex tw-items-center">
        <nz-select formControlName="smokeFrequency" nzBorderless class="tw-w-full">
          <nz-option *ngFor="let frequency of frequencies" [nzValue]="frequency.value" [nzLabel]="frequency.label"></nz-option>
        </nz-select>
      </div>
      <div nz-col nzXs="24" nzMd="8">
        <div class="tw-flex tw-flex-col tw-items-start">
          <p class="text-info tw-mr-2 tw-mb-1">¿Cuántos cigarros fuma al día?</p>
          <app-input-number [min]="0" [formControl]="form.controls['cigarettesPerDay']"></app-input-number>
        </div>
      </div>
    </div>
  </div>

  <div class="tw-mt-5 tw-p-5 tw-rounded-md tw-border tw-border-solid tw-border-gray-100">
    <div nz-row [nzGutter]="[30, 30]">
      <div nz-col nzXs="24" nzMd="8">
        <label nz-checkbox formControlName="drinkCoffee" class="tw-flex tw-items-center tw-h-full">
          <div class="tw-flex tw-items-center">
            <img src="./../../../assets/images/icons/icons8-coffee-pot-100.png" class="tw-w-8 tw-mr-2" alt="">
            <p class="text-info">¿Toma café?</p>
          </div>
        </label>
      </div>
      <div nz-col nzXs="24" nzMd="8" class="tw-flex tw-items-center">
        <nz-select formControlName="drinkCoffeeFrequency" nzBorderless class="tw-w-full">
          <nz-option *ngFor="let frequency of frequencies" [nzValue]="frequency.value" [nzLabel]="frequency.label"></nz-option>
        </nz-select>
      </div>
      <div nz-col nzXs="24" nzMd="8">
        <div class="tw-flex tw-flex-col tw-items-start">
          <p class="text-info tw-mr-2 tw-mb-1">¿Cuántas tazas toma al día?</p>
          <app-input-number [min]="0" [formControl]="form.controls['cupCoffeePerDay']"></app-input-number>
        </div>
      </div>
    </div>
  </div>
</form> -->
